import React from "react";
import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="bg-white py-10 sm:py-16 text-center font-poppins">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <h2
          className="text-xl sm:text-2xl lg:text-3xl font-extrabold mb-3 font-poppins"
          style={{ color: "#0F1030" }}
        >
          Need Professional HVAC Services in Kampala?
        </h2>
        <p className="text-gray-500 mb-6 sm:mb-8 text-sm">
          Our team is ready to design, install, or maintain HVAC systems for your home or business.
        </p>
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
          {/* Get a Quote → contact page */}
          <Link
            to="/contact"
            className="text-white font-bold px-6 sm:px-7 py-2 sm:py-3 rounded-lg transition-colors shadow-md hover:opacity-90 font-poppins text-sm sm:text-base"
            style={{ backgroundColor: "#0F1030" }}
          >
            Get a Quote
          </Link>

          {/* Call Us → direct phone call */}
          <a
            href="tel:+256200937979"
            className="font-semibold px-6 sm:px-7 py-2 sm:py-3 rounded-lg transition-colors hover:opacity-80 font-poppins text-sm sm:text-base"
            style={{ border: "2px solid #0F1030", color: "#0F1030" }}
          >
            Call Us
          </a>
        </div>
      </div>
    </section>
  );
}